export default __webpack_public_path__ + "static/masthead-70e9b2dc874ac6d0a7d01b40cd7b9f19.jpg";